import { useTranslation } from 'react-i18next';
import { useParams, useSearchParams } from 'react-router-dom';

import { useInvitation } from 'src/hooks/api';
import { useInvitationAuthorization } from 'src/modules/Invitations/Invitation';
import { StandardRouteParams } from 'src/types';

export const DynamicInvitationBreadcrumb = () => {
  const { t } = useTranslation(['common']);

  const { code } = useParams<StandardRouteParams>();
  const [searchParams] = useSearchParams();
  const applicationId = searchParams.get('applicationId') ?? undefined;
  const tenantId = searchParams.get('tenantId') ?? undefined;

  const { isError: isErrorEvaluations, isPending: isPendingEvaluations } =
    useInvitationAuthorization({ applicationId, tenantId });

  const { data, error, isPending } = useInvitation(code, {
    // Only fetch once the user is confirmed authorized
    enabled: !isPendingEvaluations && !isErrorEvaluations,
  });

  if (isPending || isPendingEvaluations) {
    return t('common:loadingFeedback.loading');
  }

  if (error || isErrorEvaluations) {
    return t('common:error.error');
  }

  return data.code;
};
